import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";

import Banner from "../components/contentfulModal/banner";
import DonateRenewForm from "../components/form/renewForm";
import useClientSide from "../hooks/useClientSide";
import useHandlePaypalUpdate from "../hooks/useHandlePaypalUpdate";
import useHandleCreditCardUpdate from "../hooks/useHandleCreditCardUpdate";
import useHandleApplePayUpdate from "../hooks/useHandleApplePayUpdate";
import { PAYMENT_GATEWAY_FATZEBRA } from "../utilities/paymentGateway";

import Seo from "../components/seo";
import { buildBreadcrumbBySlug } from "../utilities/schema";

const RenewPage = ({
  data: {
    contentfulDonationRenew: {
      headerBanner,
      successPage,
      successUrl,
      failPage,
      failUrl,
    },
  },
}) => {
  const isClientSide = useClientSide();
  useHandlePaypalUpdate(isClientSide);
  useHandleCreditCardUpdate(isClientSide);
  useHandleApplePayUpdate(isClientSide);

  const paymentGateway = PAYMENT_GATEWAY_FATZEBRA;

  // console.log(headerBanner, successPage, successUrl, failPage, failUrl);
  return (
    <Layout isDonationHeader={true}>
      {headerBanner ? <Banner bannerData={headerBanner} forceH1={true} breadcrumbSettings={{hideBreadcrumb: true}}/> : ""}
      <DonateRenewForm
        successPage={successUrl ?? successPage?.slug ?? null}
        failPage={failUrl ?? failPage?.slug ?? null}
        paymentGateway={paymentGateway}
      />
    </Layout>
  );
};

export default RenewPage;

export const Head = ({
  data: {
    contentfulDonationRenew: { title, slug },
  },
}) => {
  const breadcrumbSchema = buildBreadcrumbBySlug({ slug, title });

  return (
    <>
      <Seo title={title} slug={slug} />
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </>
  );
};

export const query = graphql`
  query ($slug: String!) {
    contentfulDonationRenew(slug: { eq: $slug }) {
      name
      title
      slug
      headerBanner {
        ...Banner
      }
      successPage {
        slug
      }
      successUrl
      failPage {
        slug
      }
      failUrl
    }
  }
`;
